module.exports = __webpack_public_path__ + "static/media/2DGACM16.9a4c5286.jpg";